module.exports = __webpack_public_path__ + "static/media/spinner.c4b03f9b.gif";